<svg xmlns="http://www.w3.org/2000/svg">
  <use [attr.href]="type() | iconPath"></use>
</svg>